export function ShippingReturnsPage() {
    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-3xl mx-auto px-6">
                <div className="mb-16">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">Policies</p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">Shipping & Returns</h1>
                </div>
                <div className="space-y-12 text-stone-600 font-light leading-relaxed">
                    <div>
                        <h2 className="font-serif text-2xl font-light italic text-stone-900 mb-4">Shipping</h2>
                        <ul className="space-y-3 text-sm">
                            <li>Standard UK delivery (3–5 business days) — <span className="text-stone-900">£4.50</span></li>
                            <li>Express UK delivery (1–2 business days) — <span className="text-stone-900">£9.00</span></li>
                            <li>Free standard shipping on orders over <span className="text-stone-900">£60</span></li>
                            <li>International shipping available to EU and US — rates calculated at checkout</li>
                        </ul>
                        <p className="text-sm mt-4">All orders are processed within 1–2 business days. You'll receive a tracking number once your order ships.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-2xl font-light italic text-stone-900 mb-4">Returns</h2>
                        <ul className="space-y-3 text-sm">
                            <li>We accept returns within <span className="text-stone-900">30 days</span> of delivery</li>
                            <li>Items must be unused and in original packaging</li>
                            <li>Personalised or sale items are non-returnable</li>
                            <li>Return shipping is the customer's responsibility unless the item is faulty</li>
                        </ul>
                        <p className="text-sm mt-4">To initiate a return, please email us at <span className="text-stone-900">returns@beetrele.com</span> with your order number.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
